import React from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";
import { FormattedMessage } from "react-intl";
import { Row } from "components/Containers";
import Overlay from "components/Overlay";
import { PopoverCard } from "components/ActivityLog";
import { colors, fontSize } from "style";

/**
 * ApplicantMissionActiveCount
 *
 * @param {Object} data
 */
const ApplicantMissionActiveCount = ({ data }) => (
  <Row noWrap>
    {data?.activeApplicationCount > 0 && data?.activeApplicationRoles ? (
      <Overlay
        overlay={
          <PopoverCard paddingBottom>
            {data?.activeApplicationRoles?.map((role, i) => (
              <p key={i}>{role.name}</p>
            ))}
          </PopoverCard>
        }
        trigger={
          <Row gap="0.4rem" noWrap>
            <FormattedMessage
              id="Missions.Applicants.ApplicantMissionActiveCount"
              values={{
                count: <div css={styles.icon_container}>{data?.activeApplicationCount}</div>,
              }}
            />
          </Row>
        }
        placement="top"
      />
    ) : (
      <Row gap="0.4rem" noWrap>
        <FormattedMessage
          id="Missions.Applicants.ApplicantMissionActiveCount"
          values={{
            count: <div css={styles.icon_container}>{data?.activeApplicationCount}</div>,
          }}
        />
      </Row>
    )}
  </Row>
);

const styles = {
  icon_container: css`
    border-radius: 1rem;
    background: ${colors.grayAnatomyLight3};
    font-size: ${fontSize.xxsmall};
    width: 3.5rem;
    height: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
  `,
};

ApplicantMissionActiveCount.propTypes = {
  data: PropTypes.shape({
    activeApplicationCount: PropTypes.number,
    activeApplicationRoles: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
};

export default ApplicantMissionActiveCount;
